<template lang="pug">
  extends ../base/base.pug
  block input
    b-row
      b-col(md)
        label(
          v-bind:for="slug + multi_field_num"
        )
          = '{{ question }}'
          span(
            v-if="is_required"
            class="requiredField"
          ) *
      b-col(md)
        b-form-select(
          v-model="local_answer"
          :id="slug + multi_field_num"
          @change="process_change()"
          :required="is_required"
          :state="get_state"
          :options="options"
        )
        b-form-invalid-feedback
          = '{{ error_message }}'
        b-form-text
          = '{{ helper }}'
</template>
<script>
import Base from "../base";
import { mapActions } from "vuex";

export default {
	extends: Base,
	computed: {
		options: {
			get() {
				return [
					{
						value: "",
						text: ""
					},
					...this.$store.state[this.slug].options
				];
				//return this.$store.state[this.slug].options;
			}
		},
		dependent_answer: {
			get() {
				let dep = this.$store.state[this.slug].option_source_dependent;
				if (dep) {
					return this.$store.state[dep].answer;
				} else {
					return null;
				}
			}
		}
	},
	methods: {
		...mapActions({
			get_options: "dynamicDDLQuestion/get_options"
		})
	},
	watch: {
		dependent_answer(new_answer, old_answer) {
			this.get_options(this.slug);
			if (old_answer !== null) {
				this.answer = "";
				this.$store.dispatch(this.slug + "/send_answer", this.slug);
			}
		}
	},
	created() {
		this.get_options(this.slug);
	}
};
</script>
